/**
 * @file 读 cooke
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/cookie
 */

import { areCookiesEnabled } from './detectStorageAvailability';

/**
 * 转义正则关键字字符
 *
 * @param {string} string 需要转义的字符
 * @return {string} 转义后的字符
 * @inner
 */
var escapeRegExp = function escapeRegExp(string) {
  return String(string).replace(/([\$\(-\+\x2D-\/\?\[-\^\{-\}])/g, '\\$1');
};
var CAN_I_USE_COOKIE = areCookiesEnabled();
export default {
  /**
   * 读取 Cookie 中指定键的值
   *
   * @param {string} key 要读取的 Cookie 键名
   * @param {string=} [cookie=document.cookie] 要读取的 Cookie
   * @return {string}
   */
  get: function get(key) {
    var cookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!CAN_I_USE_COOKIE) {
      return '';
    }
    var cookieValue = cookie;
    if (typeof document !== 'undefined' && !cookieValue) {
      var _document = document,
        _cookie = _document.cookie;
      cookieValue = _cookie;
    }
    var value = cookieValue.match("(?:^|;)\\s*".concat(escapeRegExp(key), "=([^;]*)"));
    return value ? decodeURIComponent(value[1]) : '';
  },
  /**
   * 设置 Cookie 中指定键的值，实现方式参照 mdn 使用 cookie.set(key, value, options)
   *
   * @param {string} key 要读取的 Cookie 键名
   * @param {string} value 要设置的 Cookie 值
   * @param {Object} options 要设置的 Cookie 的配置信息
   * @return {boolean} cookie 设置是否成功
   */
  set: function set() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!CAN_I_USE_COOKIE) {
      return false;
    }
    var _options$end = options.end,
      end = _options$end === void 0 ? '' : _options$end,
      _options$path = options.path,
      path = _options$path === void 0 ? '' : _options$path,
      _options$domain = options.domain,
      domain = _options$domain === void 0 ? '' : _options$domain,
      _options$sameSite = options.sameSite,
      sameSite = _options$sameSite === void 0 ? 'Lax' : _options$sameSite,
      _options$secure = options.secure,
      secure = _options$secure === void 0 ? false : _options$secure;
    if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
      return false;
    }
    var sExpires = '';
    if (end) {
      if (typeof end === 'number') {
        sExpires = end === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : "; max-age=".concat(end);
      } else if (end instanceof Date) {
        sExpires = "; expires=".concat(end.toUTCString());
      } else {
        sExpires = "; expires=".concat(end);
      }
    }
    var sKeyValue = "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
    var sDomain = domain ? "; domain=".concat(domain) : '';
    var sPath = path ? "; path=".concat(path) : '';
    var sSameSite = "; SameSite=".concat(sameSite);
    var sSecure = secure ? '; Secure' : '';
    document.cookie = "".concat(sKeyValue).concat(sExpires).concat(sDomain).concat(sPath).concat(sSameSite).concat(sSecure);
    return true;
  }
};